import type {
    CreateThemeKey
} from "./settings";
import {
    type ColorVector,
    getCvdDeltaE,
    type CvdKind,
    getDeltaE
} from "./color";

export type ChartPairDelta = {
    worstKind: CvdKind;
    isPassing: boolean;
    tritan: number;
    normal: number;
    score: number;
    cvd: number;
};

export const CHART_LIGHTNESS_BANDS: Record<CreateThemeKey, [number, number]> = {
    dark: [
        0.48,
        0.67
    ],
    light: [
        0.43,
        0.77
    ]
};

export const CHART_SERIES_PATH = "chart.categorical";

export const CHART_CHROMA_FLOOR = 0.1;

export const CHART_NORMAL_FLOOR = 15;

export const CHART_CONTRAST_MIN = 3;

export const CHART_SERIES_COUNT = 8;

export const CHART_CVD_TARGET = 8;

export const getChartPairDelta = (first: ColorVector, second: ColorVector): ChartPairDelta => {
    const protan = getCvdDeltaE({
        kind: "protan",
        second,
        first
    });

    const deutan = getCvdDeltaE({
        kind: "deutan",
        second,
        first
    });

    const normal = getDeltaE(first, second);

    const cvd = Math.min(protan, deutan);

    return {
        score: Math.min(cvd / CHART_CVD_TARGET, normal / CHART_NORMAL_FLOOR),
        isPassing: cvd >= CHART_CVD_TARGET && normal >= CHART_NORMAL_FLOOR,
        worstKind: deutan < protan ? "deutan" : "protan",
        tritan: getCvdDeltaE({
            kind: "tritan",
            second,
            first
        }),
        normal,
        cvd
    };
};
